import { render, staticRenderFns } from "./GlobalRiskMap.vue?vue&type=template&id=d2364006&scoped=true&"
import script from "./GlobalRiskMap.vue?vue&type=script&lang=js&"
export * from "./GlobalRiskMap.vue?vue&type=script&lang=js&"
import style0 from "./GlobalRiskMap.vue?vue&type=style&index=0&id=d2364006&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2364006",
  null
  
)

export default component.exports